import { createRoutine } from "../utils/routine.utils";
export var getCreateAction = function (params) {
    var entityName = params.entityName;
    return createRoutine("".concat(entityName, "_CREATE").toUpperCase());
};
